"use client";

import { HeaderContainer } from "./HeaderContainer";

export const StickyHeaderContainer = () => {
  return (
    <div className="sticky top-0 z-50 w-full">
      <HeaderContainer />
    </div>
  );
};
